"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.getStore = satcheljs_1.createStore('lightningState', {
    unseenItems: null,
    lightedCount: 0,
    lastShownId: null,
});
exports.store = exports.getStore();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-lightning-core/lib/store/store.js
// module id = 1603
// module chunks = 2 47 105 106 107